import { useCallback, useEffect, useMemo, useRef } from 'react';

interface ILatestRequestOwnership {
    begin: () => number;
    isCurrent: (requestId: number) => boolean;
    invalidate: () => void;
}

/** Guards state updates so only the latest request in a component-owned stream may commit. */
const useLatestRequest = (): ILatestRequestOwnership => {
    const requestIdRef = useRef(0);
    const mountedRef = useRef(true);

    useEffect(
        () => () => {
            mountedRef.current = false;
            requestIdRef.current += 1;
        },
        []
    );

    const begin = useCallback((): number => {
        requestIdRef.current += 1;
        return requestIdRef.current;
    }, []);
    const isCurrent = useCallback((requestId: number): boolean => mountedRef.current && requestId === requestIdRef.current, []);
    const invalidate = useCallback((): void => {
        requestIdRef.current += 1;
    }, []);

    return useMemo(() => ({ begin, isCurrent, invalidate }), [begin, invalidate, isCurrent]);
};

export default useLatestRequest;



// WEBPACK FOOTER //
// ./src/components/leases/useLatestRequest.ts